const serializationTagsDB = tag => {
  const data = structuredClone(tag)
  return data
}


export { serializationTagsDB }
